/**
 * Winter Snow Effect
 * Only active from mid-December to mid-January
 * Can be forced on via localStorage: localStorage.setItem('force-snow', 'true')
 */

(function() {
    // Check if it's mid-December to mid-January
    const now = new Date();
    const month = now.getMonth();
    const day = now.getDate();
    const isWinter = (month === 11 && day >= 15) || (month === 0 && day <= 15);

    // Also allow forcing via localStorage for testing
    const forceSnow = localStorage.getItem('force-snow') === 'true';

    if (!isWinter && !forceSnow) {
        return;
    }

    // Create canvas element
    const canvas = document.createElement('canvas');
    canvas.id = 'snow-canvas';
    canvas.style.cssText = `
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        pointer-events: none;
        z-index: 9999;
    `;
    canvas.setAttribute('aria-hidden', 'true');
    document.body.appendChild(canvas);

    const ctx = canvas.getContext('2d');
    let snowflakes = [];
    let animationId = null;

    const resizeCanvas = () => {
        canvas.width = window.innerWidth;
        canvas.height = window.innerHeight;
    };

    resizeCanvas();
    window.addEventListener('resize', resizeCanvas);

    // Create a snowflake - simple and fast
    const createSnowflake = (startAtTop = true) => {
        const depth = Math.random(); // 0 = far, 1 = close
        return {
            x: Math.random() * canvas.width,
            y: startAtTop ? Math.random() * -50 : Math.random() * canvas.height,
            size: depth * 3 + 1,
            speedY: depth * 2 + 1.5, // Faster! 1.5 to 3.5
            speedX: (Math.random() - 0.5) * 0.5,
            opacity: depth * 0.4 + 0.4,
            wobble: Math.random() * Math.PI * 2,
            wobbleSpeed: Math.random() * 0.03 + 0.01,
        };
    };

    // Initialize snowflakes
    const snowflakeCount = Math.min(120, Math.floor(window.innerWidth / 12));
    snowflakes = Array.from({ length: snowflakeCount }, () => createSnowflake(false));

    const animate = () => {
        ctx.clearRect(0, 0, canvas.width, canvas.height);

        for (let i = 0; i < snowflakes.length; i++) {
            const flake = snowflakes[i];

            // Update position
            flake.wobble += flake.wobbleSpeed;
            flake.y += flake.speedY;
            flake.x += flake.speedX + Math.sin(flake.wobble) * 0.5;

            // Reset if off screen
            if (flake.y > canvas.height + 10) {
                snowflakes[i] = createSnowflake(true);
                continue;
            }
            // Wrap horizontally
            if (flake.x > canvas.width + 10) {
                flake.x = -10;
            } else if (flake.x < -10) {
                flake.x = canvas.width + 10;
            }

            // Draw simple circle - no glow, no shadows
            ctx.beginPath();
            ctx.arc(flake.x, flake.y, flake.size, 0, Math.PI * 2);
            ctx.fillStyle = `rgba(200, 200, 210, ${flake.opacity * 0.5})`;
            ctx.fill();
        }

        animationId = requestAnimationFrame(animate);
    };

    // Start animation
    animationId = requestAnimationFrame(animate);

    // Cleanup on page unload
    window.addEventListener('beforeunload', () => {
        if (animationId) {
            cancelAnimationFrame(animationId);
        }
    });

    // Console message for testing
    console.log('❄️ Snow effect activated! To disable: localStorage.removeItem("force-snow") and refresh');
})();
